import React, {useState} from 'react';
import { useNavigate } from "react-router-dom";

import CardContainer from "../components/courseContentDisplays/CardContainer";
import {Flex} from "reflexbox";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogPopUp from "../components/common/AlertDialog";
import founders from '../images/tipping/founders.jpg'
import {Payment} from "@mui/icons-material";
import venmo from '../images/tipping/Venmo.jpg'
import paypal from '../images/tipping/Paypal.png'
import cashapp from '../images/tipping/Cashapp.jpg'
import * as route from "../components/helpers/routes";
import PageHeader from "../components/gamePlayComponents/PageHeader";

const Tipping = (props) => {
  let navigate = useNavigate();
  const viewingIndividualPage = window.location.pathname === route.TIP;
  const [tipDialog, setTipDialog] = useState(false);
  const [postTip, setPostTip] = useState(false);
  const [tipAmount, setTipAmount] = useState(1);

  let stripeLink = 'https://buy.stripe.com/bIYbLR6pm1f44vKdQU';
  if (tipAmount === 3) { stripeLink = 'https://buy.stripe.com/3cs7vB2963nc9Q46op'}
  if (tipAmount === 5) { stripeLink = 'https://buy.stripe.com/eVacPVfZW9LAaU88wy'}
  if (tipAmount === 10) { stripeLink = 'https://buy.stripe.com/3cs5nt9Byf5U5zO28b'}

  const returnToGame = () => {
    if (viewingIndividualPage){
      navigate(-1)
    } else {
      navigate(props.nextURL)
    }
  };


  const DollarButton = (props) => <Button variant="contained" color={postTip ? "inherit" : "primary" }
                                          onClick={() => {setTipDialog(true); setTipAmount (props.amount)}}
                                          style={{margin: '8px', width: '100%'}}> {props.children}</Button>;

  const TippingArea = (props) => (<>
    <Flex>
      <DollarButton {...props} amount={3}> $3</DollarButton>
      <DollarButton {...props} amount={5}> $5</DollarButton>
    </Flex>
    <Flex>
      <DollarButton {...props} amount={10}> $10</DollarButton>
      <DollarButton {...props} amount={1}> Other</DollarButton>
    </Flex>
  </>);

  const ReturnToGame = ( <Button variant="contained" color={postTip ? 'primary' : "inherit"} onClick={returnToGame} style={{margin: '0 8px'}}> Back to the game</Button> );

  const cardContentPreTip = (<Flex style={{flexDirection: 'column'}}>
    {props.postGame || (<>
      <Typography>Hey! We are Austin, Erik, and Alexis. We built Capital Clues for people to have
      fun and avoid expensive tours.</Typography>
    <Typography style={{fontWeight: '600', marginTop: '8px', marginBottom: '8px'}}>Enjoying the game? Please buy us a coffee or help us
      cover costs! Any amount is
      appreciated. </Typography>
    </>)}
    <Typography variant={'h6'} color={'primary'} style={{textAlign: 'center'}}>Support Amount </Typography>
    {props.postGame && <Typography style={{textAlign: 'center'}}>  If you had fun, please consider a tip!  </Typography>}
    <TippingArea />
    {props.postGame || (<><Typography variant={'h6'} style={{textAlign: 'center', marginTop: '8px'}}>No thanks </Typography>
     {ReturnToGame} </>)}
  </Flex>);

  const cardContentPostTip = (<Flex style={{flexDirection: 'column'}}>
    <Typography variant={'h6'} color={'primary'} style={{textAlign: 'center', marginBottom: '8px'}}>Thank you! </Typography>
    <Typography style={{textAlign: 'center', marginBottom: props.postGame ? null : '16px'}} > Your contribution will help us maintain and improve the app. </Typography>
    {props.postGame || ReturnToGame}
    <Typography style={{textAlign: 'center', marginTop: props.postGame ? '8px' : '32px'}} variant={'caption'}> Please try again if there was an issue: </Typography>
    <TippingArea postTip />
  </Flex>);


  const PaymentButton = (props) => (
    <Button component='a' href={props.link} target={"_blank"} variant="contained" onClick={()=> {setPostTip (true); setTipDialog(false)} }
            style={{margin: '6px 0', minHeight: '36px', backgroundColor: props.backgroundColor, color: 'white', width: '100%'}}>
      {props.buttonImg && <img src={props.buttonImg} alt={props.serviceName} style={{height: props.imgHeight}}/>}
      {props.card && <><Payment style={{paddingRight: '8px'}}/> Debit/Credit Card</>}
    </Button>
 );

  const dialogContent = (
    <Flex style={{flexDirection: 'column', textAlign: 'center'}}>
      <PaymentButton buttonImg={venmo} imgHeight={'15px'} backgroundColor={'#3191c7'} link={'https://venmo.com/code?user_id=1437873622482944985&created=1641957088.9890451&printed=1'} />
      <PaymentButton buttonImg={paypal} imgHeight={'22px'} backgroundColor={'#f7be38'} link={'https://www.paypal.me/ErikNeighbour?locale.x=en_US'} />
      <PaymentButton buttonImg={cashapp} imgHeight={'24px'} backgroundColor={'#00d54a'} link={'https://cash.app/$CapitalClues'} />
      <Typography style={{margin: '12px 0'}}> Or </Typography>
      <PaymentButton card backgroundColor={'#5f6368'} link={stripeLink} />
      <Typography style={{paddingTop: '8px'}}> Thank you in advance! Any amount is appreciated. </Typography>
    </Flex>
  );

  return (
    <>
      {viewingIndividualPage && <PageHeader title={'Support us'} goBack/>}
      <CardContainer
        alternateHeader
        cardMediaImg={props.postGame ? null : founders}
        cardContent1={postTip ? cardContentPostTip : cardContentPreTip}
        noBottomSpacer={props.postGame}
        actionsComponent={null} subheader={null}/>

      <DialogPopUp open={tipDialog} close={() => setTipDialog(false)}
                   title={'Select your preferred payment method'}
                   hideContinue
                   titleStyle={{textAlign: 'center'}}
                   body={dialogContent}/>
    </>
  )

};

export default Tipping;
